<header class="page_header">
    <div class="header_content">
      <div class="text_and_supporting_text">
        <div class="page_title">Container Inventory</div>
      </div>
      <div class="action_btn">
        
      </div>
    </div>
  </header>
  

  <app-tos-table
        [showTableStats]="false"
        [filterConfig]="containerPageConfig.filterConfig"
        [searchBarConfig]="containerPageConfig.searchBarConfig"
        [tableMeta]="tableMeta"
        [tableMenuOptions]="menuOptions"
        [(dataListRequest)]="tableListRequest"
        [dataListResponse]="tableListData"
        [(allTableRecordsSelected)]="allTableRecordsSelected"
        [(selectedItems)]="selectedItems"
        (tosTableAction)="fetchAllRecords()"
        (tableMenuOptionSelected)="handleMenuOptionSelection($event)"
    ></app-tos-table>
  